import {
  Datagrid,
  TextField,
  // SearchInput,
  TextInput,
  SelectInput,
  useTranslate,
  // FunctionField,
  // BooleanInput,
  BooleanField,
  NumberField,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { BRANCHCONFIG_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import { BranchConfigTimeField } from '../../components/domains/branch-config/BranchConfigDateField'

const BranchConfigListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${SERVICES_FIELDS}.name`)}
    // />,
    <TextInput
      key={0}
      source='branch_code'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${BRANCHCONFIG_FIELDS}.branch_code`)}
    />,
    // <TextInput
    //   key={0}
    //   source='branch_name'
    //   // InputLabelProps={{ shrink: true }}
    //   // InputProps={{ notched: false }}
    //   // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
    //   label={translate(`${BRANCHCONFIG_FIELDS}.branch_name`)}
    // />,
    <SelectInput
      key={1}
      label={`${COMMON_FIELDS}.status.label`}
      source='is_active'
      choices={[
        { id: 'true', name: `${COMMON_FIELDS}.status.choices.active` },
        { id: 'false', name: `${COMMON_FIELDS}.status.choices.inActive` },
      ]}
    />,
  ]
}

const branchConfigList = (): JSX.Element => {
  // const translate = useTranslate()
  return (
    <>
      <ListBase
        listAction={{
          hasExport: false,
        }}
        filters={BranchConfigListFilters()}
        sort={{ field: 'create_at', order: 'DESC' }}
      >
        <Datagrid rowClick='edit' bulkActionButtons={false}>
          <TextField
            source='branch_code'
            label={`${BRANCHCONFIG_FIELDS}.branch_code`}
            sortable={false}
          ></TextField>
          <TextField
            source='branch_name_th'
            label={`${BRANCHCONFIG_FIELDS}.branch_name_th`}
            sortable={false}
          ></TextField>
          <NumberField
            source='slot'
            label={`${BRANCHCONFIG_FIELDS}.slot`}
            sortable={false}
            textAlign='center'
          ></NumberField>
          <NumberField
            source='open_slot'
            label={`${BRANCHCONFIG_FIELDS}.open_slot`}
            sortable={false}
            textAlign='center'
          ></NumberField>
          <BranchConfigTimeField
            source='open_time'
            label={`${BRANCHCONFIG_FIELDS}.open_time`}
            showTime={true}
            textAlign='center'
            sortable={false}
          />
          <BranchConfigTimeField
            source='close_time'
            label={`${BRANCHCONFIG_FIELDS}.close_time`}
            showTime={true}
            textAlign='center'
            sortable={false}
          />
          {/* <FunctionField
            source='type'
            label={`${SERVICES_FIELDS}.type.label`}
            render={({ type }): string =>
              type === 'n'
                ? translate(`${SERVICES_FIELDS}.type.choices.normal`)
                : translate(`${SERVICES_FIELDS}.type.choices.promotion`)
            }
            // sortable={false}
          /> */}
          <DateField
            source='create_at'
            label={`${COMMON_FIELDS}.date.created_at`}
            showTime={true}
            // textAlign='center'
          />
          <DateField
            source='update_at'
            label={`${COMMON_FIELDS}.date.updated_at`}
            showTime={true}
            // textAlign='center'
          />
          <BooleanField
            source='is_active'
            label={`${COMMON_FIELDS}.status.label`}
            textAlign='center'
            sortable={false}
          />
        </Datagrid>
      </ListBase>
    </>
  )
}

export default branchConfigList
